import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  PARTNER_SETLLEMENT,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchPartnerSettlement = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.PARTNER_SETTLEMENT}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.PARTNER_SETTLEMENT}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.PARTNER_SETTLEMENT}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.PARTNER_SETTLEMENT}${query}${sorting}`);
};
const postPartnerSettlement = async payload => axiosAuthInstance.post(API_END_POINTS.ADD_PARTNER_SETTLEMENT, payload);

const partnerSettlementDelete = async ({ gid }) => axiosAuthInstance.delete(`${API_END_POINTS.ADD_PARTNER_SETTLEMENT}/${gid}`);

export function* getPartnerSettlement(action) {
  try {
    const { data: { entity } } = yield call(fetchPartnerSettlement, action.payload);
    yield put({ type: PARTNER_SETLLEMENT.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: PARTNER_SETLLEMENT.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}

export function* addPartnerSettlement(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postPartnerSettlement, action.payload);
    const { data: { entity } } = yield call(fetchPartnerSettlement, action.payload);
    yield put({ type: PARTNER_SETLLEMENT.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.PARTNER_SETTLEMENT.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* deletePartnerSettlement(action) {
  try {
    yield put({ type: LOADING.VALIDATING });
    yield put({ type: LOADING.SUBMITTING });
    yield call(partnerSettlementDelete, action.payload);
    const { data: { entity } } = yield call(fetchPartnerSettlement, action.payload);
    yield put({ type: PARTNER_SETLLEMENT.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.PARTNER_SETTLEMENT.DELETE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
